<template>
    <div v-if="notice" class="flex flex-column justify-content-start gap-2">
        <div class="flex flex-column justify-content-start gap-2 pb-2">
            <span class="notice-title">{{ notice.title }}</span>
            <span class="Paragraph-Medium"> {{ formatToDisplayDate(notice.created_at) }}</span>
            <span class="status-badge" :class="notice.published ? 'status-published' : 'status-unpublished'">
                {{ notice.published ? 'Published' : 'Unpublished' }}
            </span>
            <div class="Label notice-text" v-html="notice.description"></div>
        </div>

        <div class="flex flex-wrap justify-content-start gap-2 py-4">
            <Button label="Edit Notice" class="teal-button-small" @click="$emit('edit-notice', notice)" />
            <Button label="Delete Notice" class="p-button-outlined p-button-danger" @click="removeNotice" />
        </div>
        <ConfirmDialog></ConfirmDialog>
    </div>

    <div v-else class="p-4">Loading...</div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import Button from "primevue/button";
import { formatToDisplayDate } from "@/utils/cleanups";
import { ConfirmDialog } from "primevue";
import { useConfirm } from "primevue/useconfirm";
import { deleteNotice } from "@/api/tutor";

const confirm = useConfirm();
const props = defineProps({
    notice: {
        type: Object,
        default: null
    }
});

const emit = defineEmits(['edit-notice', 'refresh-notices']);

const removeNotice = () => {
    if (!props.notice) return;

    confirm.require({
        message: 'Do you want to delete this notice?',
        header: 'Danger Zone',
        icon: 'pi pi-info-circle',
        rejectLabel: 'Cancel',
        rejectProps: { label: 'Cancel', severity: 'secondary', outlined: true },
        acceptProps: { label: 'Delete', severity: 'danger' },
        accept: async () => {
            try {
                await deleteNotice(props.notice._id);
                emit('refresh-notices');
            } catch (error) {
                console.error("Error deleting notice:", error);
            }
        },
    });
}
</script>

<style scoped>
.p-button-danger {
    padding: 8px 16px;
    height: 34px;
    font-size: 0.75rem;
}

.notice-title {
    font-size: 1.1rem;
    font-weight: 600;
    padding-bottom: 0.5rem;
    color: black;
}

.notice-text {
    overflow: hidden;
    word-break: break-word;
}

.status-badge {
    border-radius: 50px;
    padding: 2px 8px;
    font-weight: 600;
    font-size: 0.85rem;
    width: fit-content;
    margin-top: 0.3rem;
    margin-bottom: 1rem;
}

.status-published {
    color: #10b981;
    border: 1px solid #10b981;
}

.status-unpublished {
    color: #ef4444;
    border: 1px solid #ef4444;
}
</style>